import { useEffect, useState } from "react";

const StickyHeader = ({ children }: { children: React.ReactNode }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Check if scrolling up
      if (currentScrollY < lastScrollY && currentScrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`transition-transform duration-300 ease-in-out ${
        isSticky
          ? "sm-max:sticky sm-max:top-0 sm-max:z-50 sm-max:bg-stickyHeader sm-max:text-white"
          : "relative z-50"
      }`}
    >
      {children}
    </div>
  );
};

export default StickyHeader;
